// Données fictives des aperçus. Uniquement des personnes inventées : jamais de
// nom de la base de dev ni de vrais élèves (spec § 4).

// Élèves du « Suivi des élèves » (dashboard coach web) : mêmes champs que
// l'API GetStudentScores. semaines = séances des 13 dernières semaines.
export const ELEVES = [
	{
		initiales: "CH", nom: "Chloé", entrainements: 52, joursDepuis: 0,
		semaines: [3, 4, 3, 3, 4, 3, 4, 4, 5, 4, 4, 5, 4],
		regularite: 97, seances: 4.1, progression: 52, progressees: 196, analysees: 377, regression: 8, regressees: 30,
	},
	{
		initiales: "LÉ", nom: "Léa", entrainements: 37, joursDepuis: 1,
		semaines: [2, 3, 3, 2, 3, 3, 3, 3, 2, 3, 4, 3, 3],
		regularite: 92, seances: 3.2, progression: 46, progressees: 128, analysees: 278, regression: 12, regressees: 33,
	},
	{
		initiales: "HU", nom: "Hugo", entrainements: 28, joursDepuis: 2,
		semaines: [3, 2, 3, 2, 2, 3, 2, 3, 3, 2, 3, 3, 4],
		regularite: 81, seances: 2.8, progression: 38, progressees: 87, analysees: 229, regression: 17, regressees: 39,
	},
	{
		initiales: "TH", nom: "Thomas", entrainements: 9, joursDepuis: 12,
		semaines: [2, 2, 1, 2, 1, 1, 0, 1, 0, 0, 0, 0, 0],
		regularite: 18, seances: 0.6, progression: 22, progressees: 11, analysees: 50, regression: 38, regressees: 19,
	},
];

// Reps, puis kilos et centièmes, comme les cases de l'app.
export const SERIES_TIRAGE = [
	{ numero: 1, reps: "8", kg: "82", dec: "50", derniere: "8 × 80 kg", rpe: "8", progression: true },
	{ numero: 2, reps: "8", kg: "80", dec: "00", derniere: "8 × 80 kg", rpe: "8,5", progression: false },
	{ numero: 3, reps: "7", kg: "80", dec: "00", derniere: "6 × 80 kg", rpe: "9", progression: true },
];

// 1RM estimé du développé couché, sur six mois (kg).
export const COURBE_1RM = {
	mois: ["Mai", "Juin", "Juil.", "Août", "Sept.", "Oct."],
	valeurs: [104, 105.5, 106, 108.5, 110, 112.5],
};

// Éditeur de programme : le modèle posé sur chaque jour de la semaine
// (jour 1 = lundi, comme dans CoachPrograms.js).
export const GRILLE_PROGRAMME = [
	{ jour: 1, nom: "Push" },
	{ jour: 3, nom: "Pull" },
	{ jour: 5, nom: "Jambes" },
];
